export default function Header() {
    return (
        <header className="bg-white shadow-sm z-100">
            <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold text-green-700">ACA Landscape</h1>
                <span className="text-sm text-gray-600">Schedule Your Service</span>
            </div>
            </div>
        </header>
    )
}